import React from 'react';
import { Switch, Route, withRouter, RouteComponentProps } from 'react-router-dom';
import { connect } from "react-redux";
import './styles/app.scss';
import { PATHS, NO_QUOTE_LABEL } from "./AppConstants";
import Utilities from "./classes/Utilities";
import Analytics from "./classes/Analytics";
import { IAppState } from "./state/interfaces";

import Test from "./templates/Test";
import StartQuote from "./templates/StartQuote";
import ChangeZip from "./templates/ChangeZip";
import VehicleYMM from "./templates/VehicleYMM";
import VehicleDetails from "./templates/VehicleDetails";
import HowYouDrive from "./templates/HowYouDrive"
import AboutYou from "./templates/AboutYou"
import EducationEmployment from "./templates/EducationEmployment"
import YourHome from "./templates/YourHome"
import YourLicense from "./templates/YourLicense"
import DrivingHistory from "./templates/DrivingHistory"
import Incidents from "./templates/Incidents"
import CurrentInsurance from "./templates/CurrentInsurance"
import InsuranceHistory from "./templates/InsuranceHistory"
import YourNewPolicy from "./templates/YourNewPolicy"
import ContactInfo from "./templates/ContactInfo"
import Coverages from "./templates/Coverage"
import TestCoverages from "./templates/TestCoverages"
import TestResult from "./templates/TestResult"
import Result from "./templates/Result"
import Checkout from "./templates/Checkout"
import Car from "./templates/FullQuote/Car"
import Driver from "./templates/FullQuote/Driver"
import PolicyDetails from "./templates/FullQuote/PolicyDetails"
import Finalize from "./templates/FullQuote/Finalize"
import Payment from "./templates/FullQuote/Payment"
import AdditionalDrivers from "./templates/FullQuote/AdditionalDrivers"
import Violations from "./templates/FullQuote/Violations"
import Finish from "./templates/FullQuote/Finish"
import QuoteDocuments from "./templates/FullQuote/QuoteDocuments"
import StartFullQuote from "./templates/FullQuote/StartFullQuote"
import ESignatureForm from "./templates/FullQuote/ESignatureForm"
import StartTestESignagture from "./templates/FullQuote/StartTestESignature"
import ApplicationErrorBoundary from "./ApplicationErrorBoundary"
import AgentLandingQuote from "./templates/AgentLandingQuote"
import GoodToGo from "./templates/FullQuote/GoodToGo"

interface IProps extends RouteComponentProps {
    quoteId: number | null;
}

class App extends React.Component<IProps> {

    constructor(props: IProps) {
        super(props);
    }

    componentDidUpdate(prevProps: RouteComponentProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            Analytics.onPageRouteChanged(
                this.props.quoteId?.toString() ?? NO_QUOTE_LABEL,
                prevProps.location.pathname,
                this.props.location.pathname
            );
        }
    }

    render() {
        return (
            <ApplicationErrorBoundary>
                <Switch>
                    {/*<Route path={PATHS.START} exact render={(props) => <Test {...props} id="startQuote" />} />*/}
                    <Route path={PATHS.START} exact render={(props) => <StartQuote {...props} id="startQuote" />} />
                    <Route path={PATHS.CHANGE_ZIP} exact render={(props) => <ChangeZip {...props} id="changeZip" />} />
                    { /*<Route path={Utilities.formatUrl(PATHS.VEHICLE_YMM, ":vehicleIndex(\\d+)?")} exact component={TestResult} />*/}
                    <Route path={Utilities.formatUrl(PATHS.VEHICLE_YMM, ":vehicleIndex(\\d+)?")} exact render={(props) => <VehicleYMM {...props} id="ehicleYMM" />} />
                    <Route path={Utilities.formatUrl(PATHS.VEHICLE_DETAILS, ":vehicleIndex(\\d+)?")} exact render={(props) => <VehicleDetails {...props} id="vehicleDetails" />} />
                    <Route path={Utilities.formatUrl(PATHS.HOW_YOU_DRIVE, ":vehicleIndex(\\d+)?")} exact render={(props) => <HowYouDrive {...props} id="howYouDrive" />} />
                    <Route path={Utilities.formatUrl(PATHS.ABOUT_YOU, ":driverIndex(\\d+)?")} exact render={(props) => <AboutYou {...props} id="aboutYou" />} />
                    <Route path={Utilities.formatUrl(PATHS.EDUCATION_EMPLOYMENT, ":driverIndex(\\d+)?")} exact render={(props) => <EducationEmployment {...props} id="educationEmployment" />} />
                    <Route path={Utilities.formatUrl(PATHS.YOUR_HOME, ":driverIndex(\\d+)?")} exact render={(props) => <YourHome {...props} id="yourHome" />} />
                    <Route path={Utilities.formatUrl(PATHS.YOUR_LICENSE, ":driverIndex(\\d+)?")} exact render={(props) => <YourLicense {...props} id="yourLicense" />} />
                    <Route path={Utilities.formatUrl(PATHS.DRIVING_HISTORY, ":driverIndex(\\d+)?")} exact render={(props) => <DrivingHistory {...props} id="drivingHistory" />} />
                    <Route path={Utilities.formatUrl(PATHS.INCIDENTS, ":driverIndex(\\d+)?")} exact render={(props) => <Incidents {...props} id="incidents" />} />
                    <Route path={PATHS.CURRENT_INSURANCE} exact render={(props) => <CurrentInsurance {...props} id="currentInsurance" />} />
                    <Route path={PATHS.INSURANCE_HISTORY} exact render={(props) => <InsuranceHistory {...props} id="insuranceHistory" />} />
                    <Route path={PATHS.NEW_POLICY} exact render={(props) => <YourNewPolicy {...props} id="yourNewPolicy" />} />
                    <Route path={PATHS.CONTACT_INFO} exact render={(props) => <ContactInfo {...props} id="startQuote" />} />
                    <Route path={PATHS.COVERAGES} exact render={(props) => <Coverages {...props} id="coverages" />} />
                    <Route path={PATHS.RESULT} exact render={(props) => <Result {...props} id="result" />} />
                    <Route path={PATHS.CHECKOUT} exact render={(props) => <Checkout {...props} id="checkout" />} />
                    <Route path={Utilities.formatUrl(PATHS.FQ_CARS, ":vehicleIndex(\\d+)?")} exact component={Car} key={Utilities.uniqueId()} />
                    <Route path={Utilities.formatUrl(PATHS.FQ_DRIVERS, ":driverIndex(\\d+)?")} exact component={Driver} key={Utilities.uniqueId()} />
                    <Route path={PATHS.FQ_POLICY_DETAILS} exact component={PolicyDetails} />
                    <Route path={PATHS.FQ_FINALIZE} exact component={Finalize} />
                    <Route path={PATHS.FQ_PAYMENT} exact component={Payment} />
                    <Route path={PATHS.FQ_ADDITIONAL_DRIVERS} exact component={AdditionalDrivers} />
                    <Route path={Utilities.formatUrl(PATHS.FQ_VIOLATIONS, ":driverViolationsGroupIndex(\\d+)?")} exact component={Violations} key={Utilities.uniqueId()} />
                    <Route path={PATHS.FQ_GOODTOGO} exact component={GoodToGo} />
                    <Route path={Utilities.formatUrl(PATHS.FQ_ESIGNATURE, ":formIndex(\\d+)?")} exact component={ESignatureForm} />
                    <Route path={PATHS.FQ_FINISH} exact component={Finish} />
                    <Route path={PATHS.FQ_DOCUMENTS} exact component={QuoteDocuments} id="documents" />
                    <Route path={Utilities.formatUrl(PATHS.AGENT_LANDING_QUOTE, ":quoteUid")} exact component={AgentLandingQuote} key={Utilities.uniqueId()}/>
                    </Switch>
            </ApplicationErrorBoundary>
        );
    }
}

let mapProps = (state: IAppState, ownProps: any) => {
    //console.log("state.quoteId=" + state.quoteId);
    //console.log(ownProps.location.pathname);
    return {
        quoteId: state.quoteId
    };
};

export default withRouter(connect(mapProps, null)(App));

